import type { CustomerOrderDto } from '@app/shared';
import { DataTable } from '../../components/DataTable';
import type { Column } from '../../components/DataTable';
import { StatusChip } from '../../components/StatusChip';
import { formatDateTime } from '../../lib/format';
import { useCustomerContext } from './CustomerLayout';
import { useCustomerOrders } from './api';
import { Section, userLabel } from './parts';

const COLUMNS: Column<CustomerOrderDto>[] = [
  { key: 'stage', header: 'Stage', render: (o) => o.stage },
  { key: 'orderBy', header: 'Order By', render: (o) => userLabel(o.orderBy) },
  {
    key: 'orderedAt',
    header: 'Order DateTime',
    nowrap: true,
    render: (o) => formatDateTime(o.orderedAt),
  },
  { key: 'status', header: 'Status', render: (o) => <StatusChip status={o.status} /> },
];

/** Order History (PC76): the customer's orders. So far an order is an enrollment. */
export function OrdersPage() {
  const { customer } = useCustomerContext();
  const orders = useCustomerOrders(customer.id);
  return (
    <Section title="Orders">
      <DataTable
        label="Orders"
        columns={COLUMNS}
        rows={orders.data}
        rowKey={(o) => o.enrollmentId}
        loading={orders.isFetching}
        error={orders.error}
        onRetry={() => void orders.refetch()}
        emptyText="This customer has no orders."
      />
    </Section>
  );
}
